import React, { useState, useEffect } from 'react';
import mixpanel from 'mixpanel-browser';
import { useDispatch, useSelector } from 'react-redux';

import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  Container,
  //   Avatar,
  Link,
  Button,
  MenuItem,
  Tooltip,
} from '@mui/material';

import { Menu as MenuIcon, MenuOpen as MenuOpenIcon } from '@mui/icons-material';
// import AdbIcon from '@mui/icons-material/Adb';

import SignInImg from './Cashclever.png';

import { loggedOutUser } from '../actions';

import {
  CASHCLEVER,
  HOMEPAGE,
  NONLOGGED_IN_PAGES,
  LOGGED_IN_PAGES,
  NONLOGGED_IN_SETTINGS,
  LOGGED_IN_SETTINGS,
  ALL_NON_LOGGED_IN_PAGES,
  ALL_LOGGED_IN_PAGES,
  PAGES_LINK_HREF_PATHS,
  SETTINGS_LINK_HREF_PATHS,
  TOKEN,
  LOGOUT,
  handleSettingsClick,
} from '../constants';

import { useLocalStorage } from '../CustomHooks/useLocalStorage';

import './NavBar.css';

function ResponsiveAppBar({ currentPath = HOMEPAGE, userId }) {
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [pages, setPages] = useState(ALL_NON_LOGGED_IN_PAGES);
  const [currentPages, setCurrentPages] = useState(ALL_NON_LOGGED_IN_PAGES);
  const dispatch = useDispatch();

  const { jwt } = useSelector(({ userReducer: { jwt } }) => ({
    jwt,
  }));

  const [value] = useLocalStorage(TOKEN);

  useEffect(() => {
    if (!value && !jwt) {
      setPages(ALL_NON_LOGGED_IN_PAGES);
      setCurrentPages(ALL_NON_LOGGED_IN_PAGES);
      return;
    }

    if (value || jwt) {
      if (!localStorage.getItem(TOKEN)) {
        setPages(ALL_NON_LOGGED_IN_PAGES);
        setCurrentPages(ALL_NON_LOGGED_IN_PAGES);
        return;
      }
      let user = atob(localStorage.getItem(TOKEN)?.split('.')?.[1]);
      user = JSON.parse(user);

      const date = new Date(user.exp * 1000);
      const now = new Date();
      if (date < now) {
        handleSettingsClick[LOGOUT]?.(dispatch, user);
      }

      if (user?.email) {
        setPages(ALL_LOGGED_IN_PAGES);
        setCurrentPages(ALL_LOGGED_IN_PAGES);
      }
    }
  }, [value, jwt]);

  useEffect(() => {
    if (currentPath === HOMEPAGE && !userId && !value && !jwt) {
      setPages(ALL_NON_LOGGED_IN_PAGES);
      setCurrentPages(ALL_NON_LOGGED_IN_PAGES);
    }
  }, [currentPath, userId, value, jwt]);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
    mixpanel.track('NavBar Dropdown', {
      distinct_id: userId,
      path: currentPath,
      action: event.currentTarget?.attributes?.['aria-label']?.value,
    });
  };

  const handleCloseNavMenu = (page) => {
    setAnchorElNav(null);
    handleSettingsClick[page]?.(dispatch, { id: userId });
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
    mixpanel.track('NavBar Dropdown', {
      distinct_id: userId,
      path: currentPath,
      action: 'Close',
    });
  };

  const handleClick = (page) => {
    handleSettingsClick[page]?.(dispatch, { id: userId });

    mixpanel.track('NavBar Page', {
      distinct_id: userId,
      path: currentPath,
      action: page,
    });
  };

  return (
    <AppBar sx={{ backgroundColor: 'black' }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontWeight: 700,
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            <img src={SignInImg} height="30" width="30" className="cash-clever-logo" />
            {CASHCLEVER}
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' }, visibility: 'hidden' }}>
            <IconButton
              size="large"
              aria-label=""
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
            >
              {pages.map((page) => {
                return (
                  <MenuItem key={page} onClick={handleCloseNavMenu}>
                    <Typography sx={{ textAlign: 'center' }}>
                      <Link
                        variant="filled"
                        href={PAGES_LINK_HREF_PATHS[page]}
                        sx={{ textDecoration: 'none', color: 'black' }}
                      >
                        {page}
                      </Link>
                    </Typography>
                  </MenuItem>
                );
              })}
            </Menu>
          </Box>
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontWeight: 700,
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            <img src={SignInImg} height="30" width="30" className="cash-clever-logo" />
            {CASHCLEVER}
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'end' }}>
            {pages.map((page) => (
              <Button
                key={page}
                onClick={
                  currentPath !== page
                    ? () => handleCloseNavMenu(page)
                    : (e) => {
                        e.preventDefault();
                      }
                }
                sx={{
                  '&:hover': { backgroundColor: 'white', color: 'black' },
                  my: 2,
                  color: 'white',
                  display: 'block',
                  justifyContent: 'end',
                  border: currentPath === page ? '1px solid white' : '',
                }}
                href={PAGES_LINK_HREF_PATHS[page]}
              >
                {page}
              </Button>
            ))}
          </Box>
          <Box className="page-menu-dropdown" sx={{ flexGrow: 0 }}>
            <Tooltip title="Open">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                {Boolean(anchorElUser) ? (
                  <MenuOpenIcon sx={{ color: 'white' }} />
                ) : (
                  <MenuIcon sx={{ color: 'white' }} />
                )}
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {currentPages.map((page) => (
                <MenuItem key={page} onClick={handleCloseUserMenu}>
                  <Typography sx={{ textAlign: 'center' }}>
                    <Link
                      variant="filled"
                      href={PAGES_LINK_HREF_PATHS[page]}
                      sx={{ textDecoration: 'none', color: 'black' }}
                      onClick={() => handleClick(page)}
                    >
                      {page}
                    </Link>
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default ResponsiveAppBar;
